import { render, staticRenderFns } from "./FatherIcon.vue?vue&type=template&id=01f820aa"
import script from "./FatherIcon.vue?vue&type=script&lang=js"
export * from "./FatherIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports